import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDrawer3"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H11V19H6V21H4V19H2V4ZM9 13V9H7V13H9Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18 19H13V4H22V19H20V21H18V19ZM15 9H17V13H15V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer3;
